import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "../api/dashboardApi";

// filtros: { ano, mes, dataInicio, dataFim } — nenhum deles = "todos os períodos".
export function useDashboardOverviewQuery(filtros = {}) {
  return useQuery({ queryKey: ["dashboard", "overview", filtros], queryFn: () => dashboardApi.overview(filtros) });
}
